<template>
  <div class="navbar">
    <div class="home">
      HOME 
    </div>
    <div class="content">
      <span class="el-icon-arrow-right"></span>
      <el-cascader
        :options="options"
        separator=">">
      </el-cascader>
     <!-- <div class="elicut create-event btn-c"> 
        Rechercher une fiche
      </div>-->
    </div>
  </div>
</template>

<script>
import { Component, BaseComponent } from '@/libs/BaseComponent'

@Component({
})
export default class Navbar extends BaseComponent {

  options = [
    {
      value: 'ex-1',
      label: 'Exercice 1',
      children: [
        {value: 'prog-1',
        label: 'Programme 1',
        children: [
          {value: 'serv-1',
          label: 'Service 1',
          children: [{
            value: 'act-1',
            label: 'Activité 1',
            children: [{
              value: 'Fiche-1',
              label: 'Fiche 1'},
              {
              value: 'Fiche-2',
              label: 'Fiche 2'},
              {
              value: 'Fiche-3',
              label: 'Fiche 3'}
            ]}
          ]}
        ]}
      ]
    }
  ]
}
</script>

<style lang="scss" scoped>
  .navbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 48px;
    background: #181818;
    color: #8a8b8f;
    padding-left:20px;

    .create-event {
      padding:  6px 10px;
      background: #fdd318;
      border-radius: 0 8px 8px 0;
      color: #333;
      cursor: pointer;

      &:hover {
        filter: brightness(120%);
      }
    }
    .home {
      display: flex;
      font-size: 14px;
      padding: 6px;
      border-radius: 6px;
      color: #8a8b8f;
      background: #27282a;
      border: 1px solid #111;
      cursor: pointer;

      &:hover {
        color: #ddd;
        border: 1px solid #ddd;
      }

    }
    .content {
      flex: 1;
      height: 100%;
      display: flex;
      align-items: center;
    }
  }
</style>

<style lang="scss">
  .navbar {

    .el-cascader {
      width: 80%;
    }
    .el-cascader__label {
      color: #ddd;

      & span {
        color: #da140a;
      }
    }
    .el-input__inner{
      background-color: #27282a;
      border: 1px solid transparent;
    }
  }
</style>
